
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component({})
    export default class DocumentCategorySelectItem extends Vue {
        @Prop({ type: Object, required: true }) item!: any;
    }
